import { apiClient, extractApiError } from './api';
import { Provider, ProviderType, ApiResponse } from '@/types';

class ProviderService {
  /**
   * Search for providers with filters
   */
  async searchProviders(filters: any): Promise<Provider[]> {
    try {
      const response = await apiClient.get<ApiResponse<{ providers: Provider[], total: number }>>('/providers/search', { params: filters });
      return response.data.data?.providers || [];
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Get provider details by ID
   */
  async getProviderDetail(id: string): Promise<Provider> {
    try {
      const response = await apiClient.get<ApiResponse<Provider>>(`/providers/${id}`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Get recommended providers (nearest/top rated)
   */
  async getRecommendedProviders(latitude?: number, longitude?: number): Promise<Provider[]> {
    try {
      const params = latitude && longitude ? { latitude, longitude } : {};
      const response = await apiClient.get<ApiResponse<Provider[]>>('/providers/recommended', { params });
      return response.data.data || [];
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Submit a rating for a provider
   */
  async rateProvider(id: string, rating: number, comment?: string): Promise<void> {
    try {
      await apiClient.post(`/providers/${id}/rate`, { rating, comment });
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Get provider types for filter dropdown
   */
  getProviderTypes(): { value: string; label: string }[] {
    return [
      { value: ProviderType.DOCTOR, label: 'Médecin' },
      { value: ProviderType.DENTIST, label: 'Dentiste' },
      { value: ProviderType.PHARMACY, label: 'Pharmacie' },
      { value: ProviderType.CLINIC, label: 'Clinique' },
      { value: ProviderType.HOSPITAL, label: 'Hôpital' },
      { value: ProviderType.OPTICIAN, label: 'Opticien' },
      { value: ProviderType.LABORATORY, label: 'Laboratoire' },
      { value: ProviderType.RADIOLOGY, label: 'Radiologie' },
    ];
  }
}

export const providerService = new ProviderService();
export default providerService;
